module.exports = __webpack_public_path__ + "media/images/icons/flags/SA-55cb092767e9c12dd34dc21394e9430f.svg";